export enum access {
  RetailInsights = 'Retail Insights',
  Hitlists = 'Retail Products',
  MarketPremium = 'Retail Market Premium',
  KeyAccount = 'Retail Key Account',
  SellerInsights = 'Retail Marketplace Sellers',
}
